await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-events.js', false);

class MainCart extends McElement {

  connectedCallback() {
    // Setup observer per rilevare quando il DOM viene aggiornato
    this.setupReloadObserver();
    
    window.addEventListener(MCEVENTS.CART_UPDATED, () => {
      // Salva lo stato prima del reload
      this.saveCheckboxState();
      this.reload(location.href);
    });
    window.addEventListener(MCEVENTS.PROMO_APPLIED, () => {
      // Salva lo stato prima del reload
      this.saveCheckboxState();
      this.reload(location.href);
    });
    
    // Sincronizzazione checkbox con sessionStorage
    this.syncCheckboxesWithStorage();
  }
  
  setupReloadObserver() {
    // Osserva le modifiche al DOM per ripristinare lo stato dopo il reload
    const observer = new MutationObserver((mutations) => {
      // Controlla se le checkbox sono state aggiunte al DOM
      const hasCheckboxes = document.getElementById('privacyCheck') || 
                           document.getElementById('newsletterCheck') || 
                           document.getElementById('profilazioneCheck');
      
      if (hasCheckboxes) {
        // Ripristina lo stato delle checkbox
        this.syncCheckboxesWithStorage();
      }
    });
    
    // Osserva modifiche nel contenuto di main-cart
    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
  
  saveCheckboxState() {
    const privacyMain = document.getElementById('privacyCheck');
    const newsletterMain = document.getElementById('newsletterCheck');
    const profilazioneMain = document.getElementById('profilazioneCheck');
    
    if (privacyMain) {
      sessionStorage.setItem('cart_privacy_accepted', privacyMain.checked);
    }
    if (newsletterMain) {
      sessionStorage.setItem('cart_newsletter_consent', newsletterMain.checked);
    }
    if (profilazioneMain) {
      sessionStorage.setItem('cart_profiling_consent', profilazioneMain.checked);
    }
  }
  
  syncCheckboxesWithStorage() {
    // Privacy checkbox
    const privacyMain = document.getElementById('privacyCheck');
    const privacyDrawer = document.getElementById('privacyCheckDrawer');
    
    // Newsletter checkbox
    const newsletterMain = document.getElementById('newsletterCheck');
    const newsletterDrawer = document.getElementById('newsletterCheckDrawer');
    const newsletterHiddenMain = document.getElementById('newsletterConsentHidden');
    const newsletterHiddenDrawer = document.getElementById('newsletterConsentHiddenDrawer');
    
    // Profilazione checkbox
    const profilazioneMain = document.getElementById('profilazioneCheck');
    const profilazioneDrawer = document.getElementById('profilazioneCheckDrawer');
    const profilingHiddenMain = document.getElementById('profilingConsentHidden');
    const profilingHiddenDrawer = document.getElementById('profilingConsentHiddenDrawer');
    
    // Carica stato iniziale da sessionStorage
    const loadStateFromStorage = () => {
      const privacyState = sessionStorage.getItem('cart_privacy_accepted') === 'true';
      const newsletterState = sessionStorage.getItem('cart_newsletter_consent') === 'true';
      const profilingState = sessionStorage.getItem('cart_profiling_consent') === 'true';
      
      if (privacyMain) privacyMain.checked = privacyState;
      if (privacyDrawer) privacyDrawer.checked = privacyState;
      
      if (newsletterMain) newsletterMain.checked = newsletterState;
      if (newsletterDrawer) newsletterDrawer.checked = newsletterState;
      if (newsletterHiddenMain) newsletterHiddenMain.value = newsletterState ? 'true' : 'false';
      if (newsletterHiddenDrawer) newsletterHiddenDrawer.value = newsletterState ? 'true' : 'false';
      
      if (profilazioneMain) profilazioneMain.checked = profilingState;
      if (profilazioneDrawer) profilazioneDrawer.checked = profilingState;
      if (profilingHiddenMain) profilingHiddenMain.value = profilingState ? 'true' : 'false';
      if (profilingHiddenDrawer) profilingHiddenDrawer.value = profilingState ? 'true' : 'false';
    };
    
    // Carica stato iniziale
    loadStateFromStorage();
    
    // Privacy checkbox handlers
    if (privacyMain) {
      privacyMain.addEventListener('change', (e) => {
        sessionStorage.setItem('cart_privacy_accepted', e.target.checked);
        if (privacyDrawer) privacyDrawer.checked = e.target.checked;
      });
    }
    
    if (privacyDrawer) {
      privacyDrawer.addEventListener('change', (e) => {
        sessionStorage.setItem('cart_privacy_accepted', e.target.checked);
        if (privacyMain) privacyMain.checked = e.target.checked;
      });
    }
    
    // Newsletter checkbox handlers
    if (newsletterMain) {
      newsletterMain.addEventListener('change', (e) => {
        const value = e.target.checked ? 'true' : 'false';
        sessionStorage.setItem('cart_newsletter_consent', e.target.checked);
        if (newsletterDrawer) newsletterDrawer.checked = e.target.checked;
        if (newsletterHiddenMain) newsletterHiddenMain.value = value;
        if (newsletterHiddenDrawer) newsletterHiddenDrawer.value = value;
      });
    }
    
    if (newsletterDrawer) {
      newsletterDrawer.addEventListener('change', (e) => {
        const value = e.target.checked ? 'true' : 'false';
        sessionStorage.setItem('cart_newsletter_consent', e.target.checked);
        if (newsletterMain) newsletterMain.checked = e.target.checked;
        if (newsletterHiddenMain) newsletterHiddenMain.value = value;
        if (newsletterHiddenDrawer) newsletterHiddenDrawer.value = value;
      });
    }
    
    // Profilazione checkbox handlers
    if (profilazioneMain) {
      profilazioneMain.addEventListener('change', (e) => {
        const value = e.target.checked ? 'true' : 'false';
        sessionStorage.setItem('cart_profiling_consent', e.target.checked);
        if (profilazioneDrawer) profilazioneDrawer.checked = e.target.checked;
        if (profilingHiddenMain) profilingHiddenMain.value = value;
        if (profilingHiddenDrawer) profilingHiddenDrawer.value = value;
      });
    }
    
    if (profilazioneDrawer) {
      profilazioneDrawer.addEventListener('change', (e) => {
        const value = e.target.checked ? 'true' : 'false';
        sessionStorage.setItem('cart_profiling_consent', e.target.checked);
        if (profilazioneMain) profilazioneMain.checked = e.target.checked;
        if (profilingHiddenMain) profilingHiddenMain.value = value;
        if (profilingHiddenDrawer) profilingHiddenDrawer.value = value;
      });
    }
    
    // Ascolta eventi storage per sincronizzazione tra tab (opzionale)
    window.addEventListener('storage', (e) => {
      if (e.key === 'cart_privacy_accepted' || e.key === 'cart_newsletter_consent' || e.key === 'cart_profiling_consent') {
        loadStateFromStorage();
      }
    });
  }
}

if (!customElements.get('main-cart')) {
  customElements.define('main-cart', MainCart);
}

window.MainCart = MainCart;

// Assicura che lo stato venga ripristinato anche dopo il caricamento iniziale della pagina
document.addEventListener('DOMContentLoaded', () => {
  const mainCart = document.querySelector('main-cart');
  if (mainCart && mainCart.syncCheckboxesWithStorage) {
    setTimeout(() => mainCart.syncCheckboxesWithStorage(), 100);
  }
});